// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"270":"545530c1","405":"69d54ada","470":"0b92605a","838":"49ae1a78","985":"20032bc8"}[chunkId] + ".css";
};